module.exports = __webpack_public_path__ + "assets/055006c2d6589399bdc97e74564b2748.jpg";